export function randomNumericString() {
  return Math.random().toString().slice(2);
}
